import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JSONPath } from 'jsonpath-plus';
import { forkJoin, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { Award, AwardWinner, Book } from '../model/models';

const WIKIDATA_URL = 'https://www.wikidata.org/wiki/Special:EntityData';

@Injectable({
  providedIn: 'root'
})
export class SemanticWebDao {

  constructor(private httpClient: HttpClient) { }

  getBook(wikidataId: string): Observable<Book> {
    return this.httpClient.get(`${WIKIDATA_URL}/${wikidataId}.json`)
      .pipe(
        mergeMap((json: any) => {
          const labels = json.entities[wikidataId].labels;

          const title: string = (labels.es ?? labels.en).value;
          const authorId: string = JSONPath({ path: `entities.${wikidataId}.claims.P50[0].mainsnak.datavalue.value.id`, json })[0];
          return this.httpClient.get(`${WIKIDATA_URL}/${authorId}`).pipe(
            map(authorJson => {
              const author = JSONPath({ path: `entities.${authorId}.labels.en.value`, json: authorJson })[0];
              return { wikidataId, title, author } as Book;
            })
          )
        }));
  }

  getAwardWinners(): Observable<AwardWinner[]> {
    return forkJoin([
      this.getEntityAwardWinners('Q255032', Award.HUGO),
      this.getEntityAwardWinners('Q2576795', Award.LOCUS),
      this.getEntityAwardWinners('Q255032', Award.NEBULA),
    ]).pipe(map(awardWinners => [].concat(...awardWinners)));
  }

  getEntityAwardWinners(entityId: string, award: Award): Observable<AwardWinner[]> {
    return this.httpClient
      .get(`${WIKIDATA_URL}/${entityId}.json`)
      .pipe(map(json => {
        const winnerQualifiers: any[] = JSONPath({ path: `$.entities.${entityId}.claims.P1346[*].qualifiers`, json });
        return winnerQualifiers.map(qualifier => {
          return ({
            bookId: JSONPath({ path: '$.P1686[*].datavalue.value.id', json: qualifier })[0],
            year: JSONPath({ path: '$.P585[*].datavalue.value.time', json: qualifier })[0].substring(1, 5),
            award
          } as AwardWinner);
        })
      }));
  }
}
